module.exports = __webpack_public_path__ + "img/22f.c74630b6.png";